
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ReasonsDto } from './reasons.dto';


export class AllReasonsResponse extends GlobalResponseObject{
    data?: ReasonsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ReasonsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

